import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_LICENSED_STATES_ACTION_TYPE } from '../actions';

const initialState = [];

const subCompanyNmlsLicensesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES:
        return payload || initialState;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES_FAILURE:
      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyNmlsLicensesReducer;
